import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GuestCardService {
  private base = environment.baseUrl;

  constructor(private http: HttpClient) {}

  getGuestCards(params: Record<string, any>): Observable<{ items: any[]; total: number }> {
    return this.http.get<{ items: any[]; total: number }>(
      `${this.base}property-yardi/guest-cards`,
      { params },
    );
  }

  getLeadSources(): Observable<string[]> {
    return this.http.get<string[]>(`${this.base}property-yardi/lead-sources`);
  }

  getPropertySourceIds(): Observable<string[]> {
    return this.http.get<string[]>(`${this.base}property-yardi/guest-card-sources`);
  }
}
